export const CONTEXTUAL_BULK_EDIT_ISSUE_LIMIT = 50; // backlog contextual menu still depends on this constant

/* deprecated - should use BULK_OPS_SELECTED_ISSUE_LIMIT in src/packages/bulk-operations/common/src/common/constants.tsx instead */
export const BULK_EDIT_SELECTED_ISSUE_LIMIT = 1000;
export const BULK_CLONE_SELECTED_ISSUE_LIMIT = 3;

/* section TESTIDs */
export const FORM_WRAPPER_TEST_ID = 'bulk-operations-core.ui.form.form-wrapper';
export const FOOTER_CANCEL_BUTTON_TEST_ID =
	'bulk-operations-core.common.ui.view-footer.cancel-button';
export const FOOTER_BACK_BUTTON_TEST_ID = 'bulk-operations-core.common.ui.view-footer.back-button';
export const FOOTER_NEXT_BUTTON_TEST_ID = 'bulk-operations-core.common.ui.view-footer.next-button';

/* Field Search */
export const FIELD_SEARCH_OPTION_HEIGHT = 40;
export const FIELD_SEARCH_OPTION_WITH_FIELD_TYPE_HEIGHT = 50;
